import { Reveal } from "@components/ui";
import frameIcon from "@assets/images/Frame.svg";
import frame1Icon from "@assets/images/Frame1.svg";
import frame2Icon from "@assets/images/Frame2.svg";
import frame3Icon from "@assets/images/Frame3.svg";
import frame4Icon from "@assets/images/Frame4.svg";
import frame5Icon from "@assets/images/Frame5.svg";

const promises = [
  {
    title: "Safety First",
    description: "We commit to zero-compromise safety practices.",
    icon: frameIcon,
  },
  {
    title: "100% Transparency",
    description: "No surprises, no hidden costs, no confusing bills.",
    icon: frame1Icon,
  },
  {
    title: "Fast Support Anytime",
    description: "Emergency hotline available day and night.",
    icon: frame2Icon,
  },
  {
    title: "Certified Technicians Only",
    description: "We never outsource to unqualified operators.",
    icon: frame3Icon,
  },
  {
    title: "Customer-Centric Service",
    description: "Your comfort and safety are our priority.",
    icon: frame4Icon,
  },
  {
    title: "Clean, Accurate Billing",
    description: "Powered by smart meters and industry-leading software.",
    icon: frame5Icon,
  },
];

export function OurPromiseSection() {
  return (
    <section className="w-full bg-[#f1f1f1] pt-[60px] md:pt-[80px] lg:pt-[100px] pb-[40px] md:pb-[50px] lg:pb-[60px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="mb-10 md:mb-12">
            <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold text-[#090d2c] tracking-[-0.04em] leading-[1.1] font-albert-sans">
              Our Promise to You
            </h2>
            <p className="mt-3 text-[18px] md:text-[20px] lg:text-[24px] text-[#62636c] tracking-[-0.04em] font-albert-sans">
              We are making these promises to you
            </p>
          </div>
        </Reveal>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-[13px] gap-y-4">
          {promises.map((promise) => (
            <Reveal key={promise.title}>
              <div className="group flex items-center justify-between bg-white rounded-[16px] border border-[rgba(98,99,108,0.25)] py-[22px] pl-6 md:pl-8 pr-5 md:pr-[30px] gap-4 md:gap-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 h-full">
                <div className="flex flex-col gap-0.5 min-w-0 flex-1">
                  <h3 className="text-[18px] md:text-[22px] lg:text-[26px] font-semibold text-black tracking-[-0.04em] font-albert-sans leading-[1.2]">
                    {promise.title}
                  </h3>
                  <p className="text-[14px] md:text-[16px] lg:text-[20px] text-[#62636c] tracking-[-0.04em] font-albert-sans leading-[1.4]">
                    {promise.description}
                  </p>
                </div>
                <img
                  src={promise.icon}
                  alt=""
                  className="w-[40px] md:w-[50px] lg:w-[60px] h-auto shrink-0 transition-transform duration-300 group-hover:scale-110"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
